

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, lastValueFrom } from "rxjs";
import { environment } from 'src/environments/environment';
import { JwtHelperService } from "@auth0/angular-jwt";
import { SocketioService } from '../socket/socketio.service';
import { esModoMarcador } from '../rbac/huella-rbac';
const helper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})


export class AuthService {

  public auth$: BehaviorSubject<any> = new BehaviorSubject(false);
  public ident$: BehaviorSubject<any> = new BehaviorSubject(false);
  public menuOption$: BehaviorSubject<any> = new BehaviorSubject(1);

  // RBAC state
  public permissions$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  public rbacRoles$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public hasRbac$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public primaryRole$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  
  private url_la: any;
  env: any = environment;
  private auth: any;
  private tokenName:any;
  constructor(
    public httpClient: HttpClient,
    public socketService: SocketioService

  ) {

    this.url_la = this.env.BASE_LA;
    this.tokenName = "x-token";
    this.main();
    

  }

  setIdent(ident:Boolean){
   localStorage.setItem('ident',ident.toString());
    this.ident$.next(ident);
  }


  setmenuOption(menuOption:any){
    localStorage.setItem('menuOption',menuOption);
     this.menuOption$.next(menuOption);
   }


  get menuOption(){

    if(localStorage.getItem('menuOption') !== this.menuOption$.getValue()){
      this.menuOption$.next(localStorage.getItem('menuOption'));
    }

    return this.menuOption$;
    
   }
  

  get ident(){

    if(localStorage.getItem('ident') !== this.ident$.getValue()?.toString()){
      this.ident$.next(localStorage.getItem('ident'));
    }
    return this.ident$.getValue();
   }

  main = () => {
    console.log('🟣 MAIN: Verificando token en localStorage...');
    
    const token = localStorage.getItem(this.tokenName);
    if (token) {
      console.log('🟣 MAIN: Token encontrado, restaurando sesión');
      // Validar que el token no esté expirado
      try {
        const isExpired = helper.isTokenExpired(token);
        if (!isExpired) {
          this.setAuthFromStorage({token});
        } else {
          console.log('🟣 MAIN: Token expirado, limpiando localStorage');
          localStorage.removeItem(this.tokenName);
          this.auth = false;
          this.auth$.next(false);
        }
      } catch (error) {
        console.error('🟣 MAIN: Error validando token:', error);
        localStorage.removeItem(this.tokenName);
        this.auth = false;
        this.auth$.next(false);
      }
    } else {
      console.log('🟣 MAIN: No hay token en localStorage');
      this.auth = false;
      this.auth$.next(false);
    }
  }


  login = async ({ username, password, forceLogin = false }: any) => {

    const headers: any = { 'content-type': 'application/json' };
    
    // Enviar device token si existe en localStorage
    const savedDeviceToken = localStorage.getItem('kredit_device_token');
    if (savedDeviceToken) {
      headers['X-Device-Token'] = savedDeviceToken;
      console.log('🔑 [AUTH] Enviando device token:', savedDeviceToken.substring(0, 20) + '...');
    }
    
    const request = {};
    const body = { username, password, role: "USER_ROLE", forceLogin };
    try {

      return lastValueFrom(this.httpClient.post<any>(`${this.baseUrl}/api/auth/login-console`, body, { headers: headers, params: request }));

    } catch (error) {

      console.error(error);

    }
  }

  /**
   * Iniciar recuperación de contraseña
   * @param username Nombre de usuario
   */
  initiatePasswordRecovery = async (username: string) => {
    const headers = { 
      'content-type': 'application/json',
      'X-Skip-Auth-Interceptor': 'true'
    };
    const body = { username };
    
    try {
      return lastValueFrom(
        this.httpClient.post<any>(`${this.baseUrl}/api/auth/password-recovery/initiate`, body, { headers })
      );
    } catch (error) {
      console.error('Error en initiatePasswordRecovery:', error);
      throw error;
    }
  }

  /**
   * Verificar código 2FA durante recuperación de contraseña
   * @param tempToken Token temporal
   * @param code Código 2FA
   * @param method Método 2FA (sms o authenticator)
   */
  verifyRecoveryCode = async (tempToken: string, code: string, method: string) => {
    const headers = { 
      'content-type': 'application/json',
      'X-Skip-Auth-Interceptor': 'true'  // Evitar redirección automática en 401
    };
    const body = { tempToken, code, method };
    
    try {
      return lastValueFrom(
        this.httpClient.post<any>(`${this.baseUrl}/api/auth/password-recovery/verify-code`, body, { headers })
      );
    } catch (error) {
      console.error('Error en verifyRecoveryCode:', error);
      throw error;
    }
  }

  /**
   * Resetear contraseña con 2FA verificado
   * @param tempToken Token temporal
   * @param newPassword Nueva contraseña
   * @param code Código 2FA
   * @param method Método 2FA (sms o authenticator)
   */
  resetPasswordWith2FA = async (tempToken: string, newPassword: string, code: string, method: string) => {
    const headers = { 
      'content-type': 'application/json',
      'X-Skip-Auth-Interceptor': 'true'
    };
    const body = { tempToken, newPassword, code, method };
    
    try {
      return lastValueFrom(
        this.httpClient.post<any>(`${this.baseUrl}/api/auth/password-recovery/reset`, body, { headers })
      );
    } catch (error) {
      console.error('Error en resetPasswordWith2FA:', error);
      throw error;
    }
  }


  reloadConsult = async () => {


    try {

      const headers = new HttpHeaders()
      .set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache');
      
      const request = {};

     return  lastValueFrom( this.httpClient.get<any>(this.baseUrl + '/api/auth/vesions', { headers: headers, params: request }));

    
  } catch (error) {

    console.error(error);

  }
}



getPersonTypeIdentity = async () => {

  const headers = { 'content-type': 'application/json' }
  const request = {};
 
  try {

    return  lastValueFrom( this.httpClient.get<any>(this.baseUrl + '/api/person/type_identity', { headers: headers, params: request }));

  } catch (error) {

    console.error(error);

  }
}



  refresh_token = async (body: any) => {

    const headers = { 'content-type': 'application/json' }
    const request = {};
    try {

      return lastValueFrom(this.httpClient.post<any>(`${this.baseUrl}/api/auth/refresh-token`, body, { headers: headers, params: request }));

    } catch (error) {

      console.error(error);

    }
  }



  get baseUrl() {

    return this.url_la;
  }

  /** El id del usuario de la sesión (el `uid` del token). Lo usa Cuentas: quien cargó no verifica. */
  get sessionUid(): string | null {
    const token: any = localStorage.getItem(this.tokenName);
    return helper.decodeToken(token)?.uid || null;
  }

  get sessionUser() {

    const token: any = localStorage.getItem(this.tokenName);
    const decodedToken = helper.decodeToken(token);
    return decodedToken?.user

  }


  

  get isAuth() {
    // Sincronizar con localStorage para evitar desincronización
    const token = localStorage.getItem(this.tokenName);
    if (token && !this.auth) {
      // Si hay token pero auth es false, restaurar sesión
      try {
        const isExpired = helper.isTokenExpired(token);
        if (!isExpired) {
          this.auth = true;
          this.auth$.next(true);
        }
      } catch (error) {
        this.auth = false;
      }
    } else if (!token && this.auth) {
      // Si no hay token pero auth es true, limpiar estado
      this.auth = false;
      this.auth$.next(false);
    }
    return this.auth;
  }

  setAuth = async (res: any) => {
    const { token } = res;

    if (token) {
      this.setToken(token);
      // Cargar datos RBAC ANTES de que el login redirija (window.location.href)
      await this.getMe();
    }
  }

  // Método para cargar auth desde localStorage sin refresh
  setAuthFromStorage = (res: any) => {
    const { token } = res;

    if (token) {
      this.setToken(token);
      this.restoreRbacFromStorage();
    }
  }

  setToken = (token: any) => {
    console.log('🟢 setToken: Guardando token en localStorage');
    localStorage.setItem(this.tokenName, token);
    console.log('🟢 setToken: Token guardado, length:', localStorage.length);

   // const expirationDate = helper.getTokenExpirationDate(token);
    //const isExpired = helper.isTokenExpired(token);

    this.auth = true;
    this.auth$.next(true);

    if(!this.socketService?.socket?.connected){
      this.socketService.setupSocketConnection(token);
    }
  }

  private isLoggingOut = false; // Flag para evitar refresh durante logout

  logout = async () => {
    console.log('🔴 AUTH SERVICE: logout() INICIADO');
    this.isLoggingOut = true; // Activar flag
    
    const token = localStorage.getItem(this.tokenName);
    console.log('🔴 AUTH SERVICE: Token presente:', !!token);
    
    // PRIMERO: Llamar al backend para limpiar activeSessionToken
    if (token) {
      try {
        const url = `${this.url_la}/api/auth/logout`;
        console.log('🔴 AUTH SERVICE: Llamando al backend para cerrar sesión...');
        
        const response = await lastValueFrom(this.httpClient.post(url, {}, {
          headers: { 
            'authorization': token,
            'X-Skip-Token-Refresh': 'true' // Header especial para evitar refresh
          }
        }));
        
        console.log('🔴 AUTH SERVICE: ✅ Sesión cerrada en backend:', response);
      } catch (error: any) {
        console.error('🔴 AUTH SERVICE: ❌ Error cerrando sesión en backend:', error);
        // Continuar con el logout local aunque falle el backend
      }
    }

    // SEGUNDO: Limpiar estado local INMEDIATAMENTE
    console.log('🔴 AUTH SERVICE: Limpiando estado local...');
    this.auth = false;
    this.auth$.next(false);
    
    // TERCERO: Limpiar localStorage pero preservar device trust token
    console.log('🔴 AUTH SERVICE: Limpiando localStorage...');
    const deviceToken = localStorage.getItem('kredit_device_token');
    localStorage.clear();
    if (deviceToken) {
      localStorage.setItem('kredit_device_token', deviceToken);
      console.log('🔴 AUTH SERVICE: Device token preservado');
    }
    
    // Verificar que se limpió correctamente
    console.log('🔴 AUTH SERVICE: localStorage después de clear():', {
      length: localStorage.length,
      keys: Object.keys(localStorage)
    });
    
    // CUARTO: Desconectar socket
    console.log('🔴 AUTH SERVICE: Desconectando socket...');
    this.socketService.disconnect();
    
    // QUINTO: Resetear otros estados
    this.setIdent(false);
    this.setmenuOption(1);

    // SEXTO: Limpiar estado RBAC
    this.permissions$.next([]);
    this.rbacRoles$.next([]);
    this.hasRbac$.next(false);
    this.primaryRole$.next(null);
    
    this.isLoggingOut = false; // Desactivar flag
    console.log('🔴 AUTH SERVICE: ✅ LOGOUT COMPLETADO');
  }

  getIsLoggingOut(): boolean {
    return this.isLoggingOut;
  }



  IsPermitid = (profiles:any = []) => {

    let sessionUser:any =  this.sessionUser?.profile || []; 

    const hasAllElems = sessionUser.some((elem:any) => profiles.includes(elem));
  
    if (hasAllElems) {
        return true;
    } else {
        return false;
    }
  
  }

  // ==================== RBAC ====================

  getMe = async () => {
    try {
      const data: any = await lastValueFrom(
        this.httpClient.get<any>(`${this.baseUrl}/api/auth/me`)
      );
      if (data) {
        const permissions = data.permissions || [];
        const rbacRoles = data.rbacRoles || [];
        const hasRbac = data.hasRbac || false;
        const primaryRole = rbacRoles.length > 0 ? rbacRoles[0] : null;

        this.permissions$.next(permissions);
        this.rbacRoles$.next(rbacRoles);
        this.hasRbac$.next(hasRbac);
        this.primaryRole$.next(primaryRole);

        // Cache en localStorage para restaurar sin request
        localStorage.setItem('rbac_permissions', JSON.stringify(permissions));
        localStorage.setItem('rbac_hasRbac', JSON.stringify(hasRbac));
        localStorage.setItem('rbac_primaryRole', JSON.stringify(primaryRole));
      }
      return data;
    } catch (error) {
      console.error('[RBAC] Error en getMe:', error);
      return null;
    }
  }

  private restoreRbacFromStorage = () => {
    try {
      const perms = localStorage.getItem('rbac_permissions');
      const hasRbac = localStorage.getItem('rbac_hasRbac');
      const primaryRole = localStorage.getItem('rbac_primaryRole');

      if (perms) this.permissions$.next(JSON.parse(perms));
      if (hasRbac) this.hasRbac$.next(JSON.parse(hasRbac));
      if (primaryRole) this.primaryRole$.next(JSON.parse(primaryRole));

      // Refrescar datos RBAC en background (sin bloquear bootstrap)
      setTimeout(() => this.getMe(), 1000);
    } catch (e) {
      console.error('[RBAC] Error restaurando desde storage:', e);
    }
  }

  /**
   * Vista previa de «Agregar permisos» (la pantalla dentro del iframe del marcador): quien administra permisos ve
   * TODO lo de la pantalla, también lo que su propio rol no tiene, para poder elegirlo. Solo cambia lo que se pinta:
   * el servidor sigue frenando por su cuenta y en el marcador nada se guarda (el interceptor bloquea lo que no es GET).
   */
  private verTodoEnMarcador = (): boolean => {
    if (!esModoMarcador(window)) return false;
    return this.permissions$.getValue().some((p: any) => {
      const code = typeof p === 'string' ? p : p?.code;
      return code === 'config.roles_permisos.update' || this.matchWildcard(code, 'config.roles_permisos.update');
    });
  }

  hasPermission = (permissionCode: string): boolean => {
    // Si el usuario no tiene RBAC, permitir todo (compatibilidad legacy)
    if (!this.hasRbac$.getValue()) return true;
    if (this.verTodoEnMarcador()) return true;
    const permissions = this.permissions$.getValue();
    if (permissions.length > 0) {
      return permissions.some((p: any) => {
        const code = typeof p === 'string' ? p : p?.code;
        return code === permissionCode || this.matchWildcard(code, permissionCode);
      });
    }
    return false;
  }

  hasAnyPermission = (permissionCodes: string[]): boolean => {
    // Si el usuario no tiene RBAC, permitir todo (compatibilidad legacy)
    if (!this.hasRbac$.getValue()) return true;
    if (this.verTodoEnMarcador()) return true;
    const permissions = this.permissions$.getValue();
    if (permissions.length > 0) {
      return permissionCodes.some(pc => permissions.some((p: any) => {
        const code = typeof p === 'string' ? p : p?.code;
        return code === pc || this.matchWildcard(code, pc);
      }));
    }
    return false;
  }

  private matchWildcard = (pattern: string, code: string): boolean => {
    if (!pattern || !code) return false;
    if (pattern === '*.*.*') return true;
    const patternParts = pattern.split('.');
    const codeParts = code.split('.');
    if (patternParts.length !== codeParts.length) return false;
    return patternParts.every((part: string, i: number) => part === '*' || part === codeParts[i]);
  }

  // Mapeo de categorías backend → módulos frontend UI (sidebar)
  // contactos solo mapea a 'contactos' — acceso a cupo/planes/pagos/etc depende de contactos.busqueda.read
  private readonly MODULE_CATEGORY_MAP: { [frontendModule: string]: string[] } = {
    contactos: ['contactos', 'cupo', 'planes', 'compras_financiadas', 'gestion_cobro', 'pagos'],
    finanzas: ['finanzas'],
    cobranza: ['cobranza'],
    credito: ['credito'],
    config: ['config'],
    reportes: ['reportes'],
    ventas: ['ventas'],
    admin: ['admin'],
    productos_compra: ['productos_compra'],
  };

  hasModuleAccess = (moduleName: string): boolean => {
    if (this.verTodoEnMarcador()) return true;
    const permissions = this.permissions$.getValue();
    const backendCategories = this.MODULE_CATEGORY_MAP[moduleName] || [moduleName];
    return permissions.some((p: any) => {
      const code = typeof p === 'string' ? p : p?.code;
      if (!code) return false;
      if (code === '*.*.*' || code.startsWith('*.')) return true;
      return backendCategories.some(cat => code.startsWith(cat + '.'));
    });
  }

  hasAnyModuleAccess = (moduleNames: string[]): boolean => {
    return moduleNames.some(m => this.hasModuleAccess(m));
  }

  /**
   * Check híbrido universal: si tiene RBAC, verifica acceso al módulo.
   * Si no tiene RBAC, verifica perfiles legacy.
   * Usar en templates: *ngIf="_auth.hasAccessOrProfile('ventas', ['OWNER','ANALIST'])"
   */
  hasAccessOrProfile = (moduleName: string, legacyProfiles: string[]): boolean => {
    if (this.hasRbac$.getValue()) {
      return this.hasModuleAccess(moduleName);
    }
    return this.IsPermitid(legacyProfiles);
  }

  /**
   * Check híbrido para submodulo específico.
   * Si tiene RBAC, verifica acceso al módulo (granularidad fina pendiente).
   * Si no tiene RBAC, verifica perfiles legacy.
   */
  hasSubmoduleAccessOrProfile = (moduleName: string, submoduleName: string, legacyProfiles: string[]): boolean => {
    if (this.hasRbac$.getValue()) {
      if (this.verTodoEnMarcador()) return true;
      const permissions = this.permissions$.getValue();
      return permissions.some((p: any) => {
        const code = typeof p === 'string' ? p : p?.code;
        if (!code) return false;
        if (code === '*.*.*') return true;
        if (code.startsWith('*.')) return true;
        const parts = code.split('.');
        if (parts[0] === moduleName && (parts[1] === '*' || parts[1] === submoduleName)) return true;
        return false;
      });
    }
    return this.IsPermitid(legacyProfiles);
  }

  /**
   * Obtiene la ruta por defecto según los permisos RBAC del usuario.
   * Retorna la primera ruta de un módulo al que el usuario tiene acceso.
   */
  getDefaultRoute = (): string => {
    if (!this.hasRbac$.getValue()) {
      return '/console/create-constacts';
    }
    const moduleRoutes = [
      { module: 'contactos', route: '/console/create-constacts' },
      { module: 'ventas', route: '/console/ventas' },
      { module: 'finanzas', route: '/console/finanzas2' },
      { module: 'cobranza', route: '/console/cobranza' },
      { module: 'credito', route: '/console/credito' },
      { module: 'config', route: '/console/parametros-sistema' },
      { module: 'reportes', route: '/console/export' },
    ];
    for (const mr of moduleRoutes) {
      if (this.hasModuleAccess(mr.module)) {
        return mr.route;
      }
    }
    return '/console/create-constacts';
  }

  requestSsoTicket(): Observable<any> {
    return this.httpClient.post(`${environment.BASE_LA}/api/auth/sso-ticket`, {});
  }

  // ==================== FIN RBAC ====================

  getProfiles = () =>{

    return {
      OWNER : 'Owner',
      ANALIST : 'Analista',
      EJECUTIVE : 'Promotor',
      ADMIN : 'Administrador',
      ACCOUNTING_ANALYST : 'Analista de Contabilidad',
    }
  }
  
getVersion = async () => {
  const url = 'assets/version.json';
  
  const timestamp = new Date().getTime();
  const noCacheUrl = `${url}?cache=${timestamp}`;
  
  
  
    const headers = new Headers();
    headers.append('Cache-Control', 'no-cache');
    headers.append('Pragma', 'no-cache');
    
    const requestOptions = {
      method: 'GET',
      headers: headers,
  };
  
    return new Promise((resolve, reject) => {
      fetch(noCacheUrl, requestOptions)
          .then(response => {
              if (!response.ok) {
                  throw new Error('Network response was not ok');
              }
              return response.json();
          })
          .then(data => {
              resolve(data);
          })
          .catch(error => {
              reject(error);
          });
  });
  }
  
}
